var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-12"},[(_vm.pictures)?_c('div',{staticClass:"gallery"},[_c('GalleryWrapper',{attrs:{"pictures":_vm.pictures,"gallery-id":_vm.id,"gallery-title":_vm.title,"settings":_vm.settings}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }